import { useState } from 'react';

import { useQuery } from '@zg-rentals/react-query5';
import { RentalManagerAddressAutocompleteWebApiHandler_autocomplete } from '@zg-rentals/ts-rental-manager-api-client';

import AutoCompleteAddresses from '../../model/AutoCompleteAddresses';

const MIN_LENGTH_REQUIRED_BY_API = 7;
const MAX_LENGTH_REQUIRED_BY_API = 100;

const useAddressAutocomplete = () => {
  const [partialAddress, setPartialAddress] = useState('');

  const queryFn = () => RentalManagerAddressAutocompleteWebApiHandler_autocomplete({ partialAddress });

  const queryHook = useQuery({
    queryKey: ['getAddressAutocomplete', partialAddress],
    queryFn: async () => {
      const data = await queryFn();
      return AutoCompleteAddresses(data);
    },
    staleTime: 10 * 1000,
    enabled: Boolean(
      partialAddress.trim().length > MIN_LENGTH_REQUIRED_BY_API &&
        partialAddress.trim().length <= MAX_LENGTH_REQUIRED_BY_API,
    ),
  });

  return [setPartialAddress, queryHook] as const;
};

export { useAddressAutocomplete };
